import React, { useState } from 'react';
import { Card, CardContent } from './ui/card';
import { Building2, Network, Zap, Map, Briefcase, X } from 'lucide-react';

const iconMap = {
  building: Building2,
  network: Network,
  zap: Zap,
  map: Map,
  briefcase: Briefcase
};

const SectorTiles = ({ sectors }) => {
  const [selectedSector, setSelectedSector] = useState(null);

  const getSectorIcon = (iconName) => {
    const Icon = iconMap[iconName] || Building2;
    return Icon;
  };

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
        {sectors.map((sector) => {
          const IconComponent = getSectorIcon(sector.icon);
          return (
            <Card
              key={sector.id}
              className="bg-navy-card border-navy-border hover-lift-enhanced group cursor-pointer sector-tile"
              onClick={() => setSelectedSector(sector)}
            >
              <CardContent className="p-8 text-center">
                <div className="w-16 h-16 bg-white bg-opacity-5 rounded-sm flex items-center justify-center mx-auto mb-6 group-hover:bg-opacity-10 group-hover:scale-110 transition-all duration-300">
                  <IconComponent className="w-8 h-8 text-white" strokeWidth={1.5} />
                </div>
                <h3 className="text-lg font-bold text-white group-hover:text-gray-100 transition-colors mb-2">
                  {sector.name}
                </h3>
                <div className="text-sm text-gray-400 group-hover:text-gray-300 transition-colors">
                  Explore →
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>

      {/* Sector Detail Modal */}
      {selectedSector && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 z-50 flex items-center justify-center p-8 animate-fade-in"
          onClick={() => setSelectedSector(null)}
        >
          <div
            className="bg-navy-card border border-navy-border rounded-sm max-w-2xl w-full p-12 relative animate-slide-up"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setSelectedSector(null)}
              className="absolute top-6 right-6 text-gray-400 hover:text-white transition-colors"
            >
              <X className="w-6 h-6" />
            </button>

            <div className="flex items-center gap-4 mb-6">
              {(() => {
                const IconComponent = getSectorIcon(selectedSector.icon);
                return (
                  <div className="w-16 h-16 bg-white bg-opacity-5 rounded-sm flex items-center justify-center">
                    <IconComponent className="w-8 h-8 text-white" strokeWidth={1.5} />
                  </div>
                );
              })()}
              <h2 className="text-3xl font-bold text-white">{selectedSector.name}</h2>
            </div>

            <p className="text-xl text-gray-300 leading-relaxed">
              {selectedSector.description}
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default SectorTiles;
